import { useMemo } from 'react';
import { routes } from '../routes';
import usePromotionalSalesPages from '../components/_pages/senior-portraits-review/usePromotionalSalesPages';

// WHERE A PACKAGE GOES ONCE ITS REVIEW PAGE IS DONE -- what pressing Continue
// on the review screen does: a promotional sales page for this pricelist when
// the school has one the student has not already bought, else the senior order
// review / the elementary past-images pitch.
//
// ONE implementation, because there is now a second caller. The sport team
// picture page SKIPS the review screen (there is nothing on it to review) and
// has to land exactly where Continue would have -- including the promo page,
// which a hand-rolled "go to /previous_images" would have silently dropped
// along with the sale.
//
// `isReady` is false until the promo question has actually been ANSWERED --
// which a failed request is not. Callers that navigate on a click (rather than
// rendering the review page) must not read `route` before then: both an
// unanswered query and a broken one look exactly like "no promos", and either
// would walk the customer past a page they should have seen. SportsTeamPicture
// falls back to the review page in that window.
export default function useAfterReviewRoute({
  packageId, schoolId, studentId, cartId, isSenior = false,
}) {
  // studentId is the INTERNAL Student id (the resource does Student.find on
  // it), the same id the review page passes as orderPackage.studentId.
  const { data: promotionalSalesPages, isLoading, isError } = usePromotionalSalesPages(
    packageId, schoolId, studentId, cartId,
  );

  const hasPromosAvailable = useMemo(() => (
    promotionalSalesPages.some((promoPage) => (
      promoPage.schoolHasAssociatedPackage && !promoPage.studentHasPurchasedPackage
    ))
  ), [promotionalSalesPages]);

  const route = useMemo(() => {
    if (hasPromosAvailable && packageId) return routes.promos(packageId);

    if (isSenior) return routes.review();

    return '/previous_images';
  }, [hasPromosAvailable, isSenior, packageId]);

  return { route, isReady: !isLoading && !isError };
}
